<div [class]="class + ' mat-elevation-z2'">
  <div class="auth-dialog--icon">
    <ng-content select="#icon"></ng-content>
  </div>
  <div class="auth-dialog--button-text">
    <p><ng-content select="#text"></ng-content></p>
  </div>
</div>
